export const ManufacturerMode = Object.freeze({
  NEW: 'new',
  EXISTING: 'existing',
});

export const BLANK_WARNING_HINT = 'blank, will not be updated';
